export default __webpack_public_path__ + "5bec86dbe3f7f580f8a6a928d04b023c.svg";